export default __webpack_public_path__ + "static/media/icon-burger.f7ce6da6.svg";